import React from "react";
import {
  AVAILABLE_LANGUAGES,
  LANGUAGE_LABELS,
  normalizeClinicianRole,
  ROLE_COPY,
  ROLE_LABELS,
} from "../registrationWizardConstants";
import RegistrationWizardState from "../registrationWizardState";

const ClinicSettingsStep = () => {
  const d = RegistrationWizardState.getStepData();
  const isSubAccount = RegistrationWizardState.isSubAccountScenario();
  const roleKey = normalizeClinicianRole(RegistrationWizardState.getRole());

  return (
    <div className="clinician-onboard-clinic-step">
      <h2 className="clinician-onboard-title">
        {isSubAccount ? "Clinic settings" : "Set up your clinic"}
      </h2>
      {isSubAccount && (
        <p className="clinician-onboard-subtitle clinician-onboard-subtitle--left">
          Configure defaults for the patients you&apos;ll work with.
        </p>
      )}

      <div className="clinician-onboard-role-section">
        <div className="clinician-onboard-role-row">
          <span className="clinician-onboard-role-label">Your role</span>
          <span className={`clinician-onboard-role-pill ${roleKey}`}>
            {ROLE_LABELS[roleKey] || roleKey}
          </span>
        </div>
        <p className="clinician-onboard-role-copy">{ROLE_COPY[roleKey]}</p>
      </div>

      <div className="clinician-onboard-field">
        <label>Default Patients Language</label>
        <select
          className="clinician-onboard-select"
          value={d.languageForPatients.value}
          onChange={(e) =>
            RegistrationWizardState.updateFields({
              languageForPatients: e.target.value,
              languageForPatientsTouched: true,
            })
          }
        >
          {AVAILABLE_LANGUAGES.map((lang) => (
            <option key={lang} value={lang}>
              {LANGUAGE_LABELS[lang] || lang}
            </option>
          ))}
        </select>
        <p className="clinician-onboard-field-hint clinician-onboard-info-hint">
          <span className="clinician-onboard-info-icon" aria-hidden="true">
            i
          </span>
          Set the default language for your patients&apos; invitation and application. Both you and
          your patients can customize this individually.
        </p>
      </div>
    </div>
  );
};

export default ClinicSettingsStep;
